<template>
  <div class="detail-box position-header" v-loading="loading">
    <navHeader :titleList="['贸易对接', '贸易对接详情']" />
    <div class="detail-content common-padding">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form
                ref="form"
                class="add-form"
                :model="form"
                label-width="120px"
            >
              <el-form-item label="发件公司：" prop="companyName">
                <el-input v-model="form.companyName" disabled></el-input>
              </el-form-item>
              <el-form-item label="企业类型：" prop="companyType">
                <el-input v-model="form.companyType" disabled></el-input>
              </el-form-item>
              <el-form-item label="联系人：" prop="contacts">
                <el-input v-model="form.contacts" disabled></el-input>
              </el-form-item>
              <el-form-item label="职位：" prop="position">
                <el-input v-model="form.position" disabled></el-input>
              </el-form-item>
              <el-form-item label="手机号码：" prop="phone">
                <el-input v-model="form.phone" disabled></el-input>
              </el-form-item>
              <el-form-item label="留言内容：" prop="detail">
                <el-input v-model="form.detail" disabled type="textarea"></el-input>
              </el-form-item>
              <el-form-item label="发信时间：" prop="createTime">
                <el-input v-model="form.createTime" disabled></el-input>
              </el-form-item>
<!--              <el-form-item label="请上传产品图册：" prop="picture">-->
<!--                &lt;!&ndash;                <uploadImage :img="pictureList" disabled />&ndash;&gt;-->
<!--                <div v-if="!form.picture">无</div>-->
<!--                <ul class="image-box" v-else>-->
<!--                  <li v-for="(item, index) in pictureList" :key="index">-->
<!--                    <el-image :src="item"  style="width: 100%; height: 100%">-->
<!--                    </el-image>-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </el-form-item>-->
            </el-form>
            <div class="info-footer">
              <el-button @click="back">返回</el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader.vue'
import uploadImage from '../../components/uploadImage.vue'
export default {
  name: 'detail',
  data () {
    return {
      loading: true,
      id: '',
      form: {
        companyName: '',
        contacts: '',
        companyType: '',
        phone: '',
        detail: '',
        position: '',
        createTime: ''
      },
      pictureList: []
    }
  },
  components: {
    navHeader,
    uploadImage
  },
  methods: {
    getDetail (id) {
      this.$http
        .post('/tradeDocking/detail', {id})
        .then((res) => {
          if (res.data.code === '200') {
            this.form = res.data.data
            if (this.form.one && this.form.two) {
              this.form.companyType = this.form.one + ' | ' + this.form.two
            } else if (this.form.one && !this.form.two) {
              this.form.companyType = this.form.one
            } else if (!this.form.one && this.form.two) {
              this.form.companyType = this.form.two
            } else {
              this.form.companyType = ''
            }
            this.loading = false
          } else {
            this.$message.error(res.data.msg)
            this.loading = false
          }
        }).catch(() => {
          this.loading = false
        })
    },
    back () {
      this.$router.back()
    }
  },
  created () {
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.getDetail(this.id)
    } else {
      this.loading = false
      // this.$message.error('ID不能为空')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/tradeDocking/detail.vue